export const SET_FEATURE_FLAGS = 'featureflags/SET_FEATURE_FLAGS'
export const SET_FEATURE_FLAGS_LOADED = 'featureflags/SET_FEATURE_FLAGS_LOADED'
